import Vue from 'vue'
import "@/element-ui";
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/theme/index.css'
import App from './App.vue'
import { isEmptyObject } from '@/assets/js/util'
import '@/assets/js/axiosInterceptors'
import router from './router'
import store from './store'
import socketIo from '@/assets/js/socketIo'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

Vue.config.productionTip = false

/**
 * 路由拦截器
 */
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (store.state.token && !isEmptyObject(store.state.user)) {  // 通过vuex state获取当前的token是否存在
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

locale.use(lang)
Vue.use(socketIo)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
